import { render } from "./Subscribe.vue?vue&type=template&id=c8ddd81a&scoped=true"
import script from "./Subscribe.vue?vue&type=script&lang=js"
export * from "./Subscribe.vue?vue&type=script&lang=js"

import "./Subscribe.vue?vue&type=style&index=0&id=c8ddd81a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8ddd81a"]])

export default __exports__